export default "__VITE_ASSET__34X4aokH__"